import React from 'react'
import { Card } from 'react-bootstrap'
import * as s from './EliminatorWinners.scss'
import EliminatorWinnerInProgress from './EliminatorWinnerInProgress'
import EliminatorWinnerCardHeader from './EliminatorWinnerCardHeader'
import EliminatorWinnerCardFooter from './EliminatorWinnerCardFooter'
import EliminatorWinnerPeople from './EliminatorWinnerPeople'

const EliminatorWinnerCard = ({ winner = {}, onClick, children, ...props }) => {
    return (
        <Card className={s.winnerCard} onClick={() => onClick(winner.seasonName)}>
            <EliminatorWinnerCardHeader {...winner} />
            <EliminatorWinnerInProgress {...winner} />
            <EliminatorWinnerPeople {...winner} />
            {children}
            <EliminatorWinnerCardFooter {...winner} />
        </Card>
    )
}

export default EliminatorWinnerCard
